<div [formGroup]="form" class="appointment-container">
  <app-form-field label="Appointment Type">
    <app-button-group
      formControlName="type"
      [options]="appointmentTypes"
    ></app-button-group>
  </app-form-field>

  <div class="date-fields-grid">
    <!-- FCFS: Two controls, each taking up half the width -->
    <app-form-field [label]="isStrict() ? 'Date & Time' : 'From Date & Time'">
      <app-datetime-picker
        formControlName="from"
        [orientation]="orientation()"
      ></app-datetime-picker>
    </app-form-field>
    @if (!isStrict()) {
    <app-form-field label="To Date & Time">
      <app-datetime-picker
        formControlName="to"
        [orientation]="orientation()"
      ></app-datetime-picker>
    </app-form-field>
    }
  </div>
</div>
